import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { CircleCheck } from "lucide-react";
export default function PartnershipValueProposition() {
  const courseTypes = [{
    id: 1,
    title: "Municipal Courses"
  }, {
    id: 2,
    title: "Daily Fee Courses"
  }, {
    id: 3,
    title: "Semi-Private Clubs"
  }, {
    id: 4,
    title: "Private Clubs"
  }, {
    id: 5,
    title: "Golf Resorts"
  }, {
    id: 6,
    title: "Practice Facilities"
  }];
  return <section className="relative bg-[#050a07] py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-30">
        <AspectRatio ratio={16 / 9} className="h-full w-full">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/cinematic_golf_landscape.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/cinematic_golf_landscape.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/cinematic_golf_landscape.png-wvc-sizes" alt="Cinematic golf course aerial view" className="h-full w-full object-cover" loading="lazy" decoding="async" />
        </AspectRatio>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050a07] via-transparent to-[#050a07]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight">
                Every Golf Course Has a <span className="text-[#b39359]">Story</span> Worth Showing
              </h2>
              <p className="font-sans text-lg md:text-xl text-white/80 leading-relaxed max-w-xl">
                From local municipal courses to destination clubs, every golf course deserves professional media that showcases its personality, layout, atmosphere, and experience.
              </p>
            </div>
            
            <div className="p-8 bg-[#0a140e]/80 backdrop-blur-sm border border-[#b39359]/20 rounded-lg shadow-xl">
              <p className="font-sans text-white/90 leading-relaxed">Trow Golf Media helps courses of all sizes modernize how they’re seen online through cinematic aerial visuals and affordable media solutions designed to elevate presentation without requiring a massive marketing budget.</p>
            </div>
          </div>

          {}
          <div className="space-y-10">
            <div className="space-y-4">
              <h3 className="font-serif text-3xl md:text-4xl text-white">
                We Work With Golf Courses Of All Types
              </h3>
              <p className="font-sans text-white/70">
                Professional golf course media shouldn’t be limited to only PGA Tour venues and luxury resorts. We offer flexible media packages designed to help golf courses of every size improve visibility, presentation, and marketing.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {courseTypes.map((type, i) => <div key={type.id} data-index={i} className="flex items-center gap-3 p-4 bg-white/5 border border-white/10 rounded-lg hover:border-[#b39359]/40 transition-colors group">
                  <CircleCheck className="h-5 w-5 text-[#b39359] shrink-0" />
                  <span className="font-sans text-white group-hover:text-[#b39359] transition-colors">
                    {type.title}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}